import React, { useState } from 'react';
import ContactForm from "../components/contact/ContactForm";
import ContactInfo from "../components/contact/ContactInfo";
import SupportTeams from "../components/contact/SupportTeams";

const Contact = () => {
    const [formSubmitted, setFormSubmitted] = useState(false);

    return (
        <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 pt-16 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 transition-colors">
            {/* Header Hero */}
            <div className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <div className="inline-flex items-center px-6 py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6">
                            <span className="w-3 h-3 bg-emerald-400 rounded-full mr-3 animate-pulse"></span>
                            <span className="text-white/90 font-semibold text-lg">SUPPORT & CONTACT</span>
                        </div>
                        <h1 className="text-4xl lg:text-5xl font-bold mb-4">
                            Nous sommes{' '}
                            <span className="bg-gradient-to-r from-amber-200 to-yellow-200 bg-clip-text text-transparent">
                                là pour vous
                            </span>
                        </h1>
                        <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
                            Notre équipe d'experts est disponible 24h/24 et 7j/7 pour vous accompagner
                            dans l'intégration et l'utilisation de Netikash.
                        </p>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid lg:grid-cols-3 gap-8 mb-16">
                    {/* Contact Info Cards */}
                    <div className="lg:col-span-1">
                        <ContactInfo />
                    </div>

                    {/* Contact Form */}
                    <div className="lg:col-span-2">
                        {formSubmitted ? (
                            <div className="bg-white rounded-2xl shadow-lg border border-amber-100/50 p-8 text-center">
                                <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">Message envoyé !</h3>
                                <p className="text-gray-700 mb-6">
                                    Merci pour votre message. Notre équipe vous répondra dans les plus brefs délais.
                                </p>
                                <button
                                    onClick={() => setFormSubmitted(false)}
                                    className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-6 py-3 rounded-lg font-medium hover:from-amber-600 hover:to-yellow-700 transition-all"
                                >
                                    Envoyer un nouveau message
                                </button>
                            </div>
                        ) : (
                            <ContactForm onSuccess={() => setFormSubmitted(true)} />
                        )}
                    </div>
                </div>

                {/* Support Teams Section */}
                <SupportTeams />

                {/* FAQ Quick Links */}
                <div className="bg-white rounded-2xl shadow-lg border border-amber-100/50 p-8 mt-12">
                    <div className="text-center mb-8">
                        <h2 className="text-3xl font-bold text-gray-900 mb-2">Questions Fréquentes</h2>
                        <p className="text-gray-700">Trouvez rapidement des réponses à vos questions</p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                        {[
                            {
                                question: "Combien de temps pour obtenir une réponse ?",
                                answer: "Notre équipe répond sous 2 heures maximum pendant les heures ouvrables."
                            },
                            {
                                question: "Quelles sont les heures de support ?",
                                answer: "Support 24h/24 et 7j/7 pour les urgences techniques."
                            },
                            {
                                question: "Comment obtenir des identifiants API ?",
                                answer: "Créez une application dans votre espace développeur Netikash."
                            },
                            {
                                question: "Y a-t-il un support téléphonique ?",
                                answer: "Oui, pour les clients enterprise avec un numéro dédié."
                            }
                        ].map((faq, index) => (
                            <div key={index} className="bg-amber-50 rounded-lg p-6 border border-amber-200">
                                <h4 className="font-semibold text-amber-800 mb-2">{faq.question}</h4>
                                <p className="text-amber-700 text-sm">{faq.answer}</p>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-8">
                        <button className="text-amber-600 hover:text-amber-700 font-medium flex items-center justify-center space-x-2 mx-auto">
                            <span>Voir toutes les FAQs</span>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;